import {Attribute} from '../../../components/ObjectAttribute';
import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const searchWorkOrdersRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/work-orders',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/work-orders' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const searchWorkOrdersResponse: Json = {
    title: 'RESPONSE',
    json: {
        'totalCount': 3,
        'totalPages': 2,
        'pageNumber': 1,
        'pageSize': 2,
        'results': [
            {
                'id': 1,
                'number': '1',
                'manufactureOrder': {
                    'id': 1,
                    'number': '1002'
                },
                'bom': {
                    'id': 12,
                    'number': 'FG2100'
                },
                'status': 'Entered',
                'locationGroup': 'SLC',
                'dateScheduledFulfillment': '2020-07-12T18:09:26.427-0600',
                'dateScheduledToStart': '2020-07-10T18:09:26.427-0600',
                'stageLevel': 1,
                'qtyOrdered': 10,
                'readOnly': false
            },
            {
                'id': 2,
                'number': '2',
                'manufactureOrder': {
                    'id': 2,
                    'number': '3'
                },
                'bom': {
                    'id': 14,
                    'number': 'TB-1000'
                },
                'status': 'Fulfilled',
                'locationGroup': 'SLC',
                'dateScheduledFulfillment': '2020-08-16T18:09:26.601-0600',
                'dateScheduledToStart': '2020-08-14T18:09:26.601-0600',
                'stageLevel': 1,
                'qtyOrdered': 10,
                'readOnly': true
            }
        ]
    },
};

const searchWorkOrdersQueryParameters: Attribute[] = [
    {
        name: 'pageNumber',
        type: 'integer',
        optional: true,
        description: 'The current page of the results.'
    },
    {
        name: 'pageSize',
        type: 'integer',
        optional: true,
        description: 'The number of returned results per page. (Default 100)'
    },
    {
        name: 'woNumber',
        type: 'string',
        optional: true,
        description: 'The work order number.',
    },
    {
        name: 'moNumber',
        type: 'string',
        optional: true,
        description: 'The manufacture order number the work order belongs to.',
    },
    {
        name: 'bomNumber',
        type: 'string',
        optional: true,
        description: 'A BOM number used in a work order.',
    },
    {
        name: 'bomDescription',
        type: 'string',
        optional: true,
        description: 'A BOM description used in a work order.',
    },
    {
        name: 'status',
        type: 'string: \'All\' | \'All Open\' | \'Entered\' | \'Started\' | \'Fulfilled\'',
        optional: true,
        description: 'The order status.',
    },
    {
        name: 'locationGroupId',
        type: 'integer',
        optional: true,
        description: 'The unique identifier of a work order\'s location group.',
    },
    {
        name: 'woCategory',
        type: 'string',
        optional: true,
        description: 'The work order\'s calendar category name.',
    },
    {
        name: 'assignedUserId',
        type: 'integer',
        optional: true,
        description: 'The unique identifier of a user assigned to the work order.',
    },
    {
        name: 'priority',
        type: 'string: \'All\' | \'1-Highest\' | \'2-High\' | \'3-Normal\' | \'4-Low\' | \'5-Lowest\'',
        optional: true,
        description: 'The work order\'s priority.',
    },
    {
        name: 'dateStartedFrom',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The start started-date cutoff for the search.'
    },
    {
        name: 'dateStartedTo',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The end started-date cutoff for the search.'
    },
    {
        name: 'dateScheduledFrom',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The start scheduled-date cutoff for the search.'
    },
    {
        name: 'dateScheduledTo',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The end scheduled-date cutoff for the search.'
    },
    {
        name: 'dateFinishedFrom',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The start finished-date cutoff for the search.'
    },
    {
        name: 'dateFinishedTo',
        type: 'date: \'yyyy-MM-dd\'',
        optional: true,
        description: 'The end finished-date cutoff for the search.'
    },
];

const searchWorkOrdersAttributes: Attribute[] = [
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of the order\'s custom fields to filter by, sent as the request body.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the custom field.',

            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
        ]
    }
];

const data: RequestDefinitionData = {
    id: 'search-work-order',
    title: 'Search for work orders',
    description: 'Searches for work orders.',
    endpoint: {
        verb: 'GET',
        path: '/work-orders',
        tooltip: 'Search for work orders',
    },
    attributes: searchWorkOrdersAttributes,
    requestObject: searchWorkOrdersRequest,
    responseObject: searchWorkOrdersResponse,
    queryParameters: searchWorkOrdersQueryParameters,
};

export default data;